// extracted by mini-css-extract-plugin
export default {"btn-wrapper":"PaymentRequestModal_btn-wrapper__C+KmA","x-btn":"PaymentRequestModal_x-btn__B0UBi","check-btn":"PaymentRequestModal_check-btn__G86UF"};